import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

window.sseConnections = window.sseConnections || [];

window.addEventListener('beforeunload', () => {
  window.sseConnections?.forEach((es) => es.close());
  window.sseConnections = [];
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
